import React from "react";
import ConsultorGenerarHojaVida from "./Hoja de Vida/GenerarHojaVida";
import ConsultorGenerarHojaVidaExcel from "./Hoja de Vida/GenerarHojaVidaExcel";
import ConsultorGenerarHojaVidaUnidad from "./Hoja de Vida/GenerarHojaVidaUnidad";

const a = <div style={{ tableLayout: "fixed" }}></div>
const CONSULTOR_ROUTES: Array<{ path: string, component: any, layout: string }> = [

    {
        path: "/ConsultorGenerarHojaVida",
        component: ConsultorGenerarHojaVida,
        layout: "/consultor"
    },
    {
        path: "/ConsultorGenerarHojaVidaExcel",
        component: ConsultorGenerarHojaVidaExcel,
        layout: "/consultor"
    },
    {
        path: "/ConsultorGenerarHojaVidaUnidad",
        component: ConsultorGenerarHojaVidaUnidad,
        layout: "/consultor"
    }

];
export default CONSULTOR_ROUTES;
